import $ from "expose-loader?exposes=$,jQuery!jquery";
import AnchorScroll from "./modules/anchor-scroll";
import SiteUnload from "./modules/site-unload";
import Navigation from "./modules/navigation";
import WbxAos from "./modules/wbx-aos";
import LazyLoad from "./modules/lazy-load";
import General from "./modules/general";
import LightGallery from "./modules/light-gallery";
import WbxFriendlyCaptcha from "./modules/wbxFriendlyCaptcha";
import FormValidation from "./modules/form-validation";
import WbxYouTubeFallback from "./modules/wbxYouTubeFallback";

import * as Popper from "@popperjs/core";
import "mdb-ui-kit/src/mdb/js/bootstrap/src/dropdown";
import "mdb-ui-kit/src/mdb/js/bootstrap/src/collapse";
import Modal from "mdb-ui-kit/src/mdb/js/bootstrap/src/modal";
import Slider from "./modules/slider";
import Counter from "./modules/counter";

new AnchorScroll();
new SiteUnload();
new Navigation();
new WbxAos();
new LazyLoad();
new General();
new LightGallery();
new WbxFriendlyCaptcha();
new FormValidation();
new WbxYouTubeFallback();
new Slider();
new Counter();

window.addEventListener("load", (e) => {
    let anchorElements = document.querySelectorAll('a');
    if (anchorElements.length) {
        let contactModal = document.querySelector('#contactModal');
        let applyModal = document.querySelector('#applyModal');
        anchorElements.forEach((v) => {
            let href = v.getAttribute('href');
            if (href && href.includes('kontakt')) {
                v.addEventListener('click', (e) => {
                    let modal = Modal.getOrCreateInstance(contactModal);
                    modal.show();
                    e.preventDefault();
                    return false;
                });
            }
            if (href && href.includes('bewerben')) {
                v.addEventListener('click', (e) => {
                    let modal = Modal.getOrCreateInstance(applyModal);
                    modal.show();
                    e.preventDefault();
                    return false;
                });
            }
        })
    }
    let fileInputs = document.querySelectorAll('input[type="file"]');
    if (fileInputs.length) {
        fileInputs.forEach(v => {
            v.addEventListener('change', () => {
                v.nextElementSibling.classList.add("d-none");
            })
        });
    }

    let informationWrapper = document.querySelectorAll('.information-wrapper');
    if (informationWrapper.length) {
        informationWrapper.forEach((v) => {
            let bg = v.closest('.bg-content-full');
            if (bg) {
                bg.style.overflow = "hidden";
            }
        });
    }
});

function requireAll(r) {
    r.keys().forEach(r);
}

requireAll(require.context('../img/icons', true, /\.svg$/));
